import { Component } from "@theme/component";
/**
 * A custom element that displays a localization form.
 *
 * @typedef {object} FormRefs
 * @property {HTMLDivElement} originalContent - The original content of the support article.
 * @extends {Component<FormRefs>}
 */
class SupportArticle extends Component {
  //requiredRefs = ["originalContent"];

  connectedCallback() {
    super.connectedCallback();

    // Check if there's a q parameter in the URL
    const urlParams = new URLSearchParams(window.location.search);
    const q = urlParams.get("q");

    if (q) {
      this.openItemByHandle(q);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  /**
   * Opens an item when a button is clicked.
   *
   * @param {Event} event - The event object.
   */
  handleToggle(event) {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;

    const handle = details.dataset.handle;

    if (!handle) return;
    const allOpenDetails = this.querySelectorAll("details[open]");
    if (details.open) {
      this.#updateUrlParams(handle);
      //close all the others
      allOpenDetails.forEach((details) => {
        if (details.getAttribute("data-handle") !== handle) {
          details.removeAttribute("open");
        }
      });
      /*details.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });*/
    } else {
      if (allOpenDetails.length == 0) {
        this.#removeUrlParams();
      }
    }
  }

  /**
   * Updates the URL parameters.
   *
   * @param {string} handle - The handle of the item to open.
   */
  #updateUrlParams(handle) {
    const url = new URL(window.location.href);
    url.searchParams.set("q", handle);
    window.history.pushState({}, "", url);
  }

  #removeUrlParams() {
    const url = new URL(window.location.href);
    url.searchParams.delete("q");
    window.history.pushState({}, "", url);
  }

  /**
   * Opens an item by its handle.
   *
   * @param {string} handle - The handle of the item to open.
   */
  openItemByHandle(handle) {
    //scroll to the item
    const item = this.querySelector("details[data-handle='" + handle + "']");
    if (item) {
      item.setAttribute("open", "");
      item.scrollIntoView({ behavior: "smooth", block: "start" });
      this.#updateUrlParams(handle);
    }
  }
}

if (!customElements.get("support-article")) {
  customElements.define("support-article", SupportArticle);
}
